import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useOnboarding } from "../../../context/AdminSellerRegistrationOB";

const Breadcrumb = ({ title, link =false, isSelectAddress = false, addressEnumChange, isChildren = false }) => {

  const { clear } = useOnboarding();
  const navigate = useNavigate();

  const handleBack = () => {
    if (isSelectAddress) {
      addressEnumChange(0);
    } else {
      if (isChildren) {
        addressEnumChange(1);
      }
    }
  }

  const resetOnboarding = () => {
  clear();
};

 useEffect(() => {
        
        console.log("link data : "+link)
    }, []);

  return (
    <div className="registration-breadcrumb">
        <div className="container">
            <div className="position-relative d-flex align-items-center justify-content-center text-center">
                {/* <Link to={link || "/seller-register-blank" } onClick={(e) => {
                  e.stopPropagation();
                  resetOnboarding();
                  // Link(link || "/seller-register-blank" );
                }} className="position-absolute start-0 text-black text-32"><i className="ph ph-arrow-left"></i>
                </Link> */}
                <button type="button" className="btn position-absolute start-0 text-black text-32"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(link, { replace: true });
                  // delay clear until after navigation
                  setTimeout(() => clear(), 0);
                  // Link(link || "/seller-register-blank" );
                }}
                >
                  <i className="ph ph-arrow-left text-black text-32"></i>
                </button>
                <div className="title text_quicksand fw-bold text-32 text-black">
                    {title}
                </div>
            </div>
        </div>
    </div>
  );
};

export default Breadcrumb;